<template>
  <v-select
    ref="controlFocoSelectCuentaBancaria"
    label="Cuenta*"
    v-model="iModel"
    :items="items"
    item-value="Id_CuentaBancaria"
    item-text="Nombre"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
export default {
  name: "SelectCuentaBancaria",
  props: {
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      rutaApi: "CuentaBancaria/",
      items: [],
      loading: false
    };
  },
  computed: {
    iModel: {
      get() {
        return this.model;
      },
      set(valor) {
        let ind = this.items.findIndex(x => x.Id_CuentaBancaria == valor);
        this.$emit("seleccionarItem", this.items[ind]);
      }
    }
  },
  created() {
    eventBus.$on("setearFocoSelectCuentaBancaria", this.setearFoco);
    this.listarItems();
  },
  beforeDestroy() {
    eventBus.$off("setearFocoSelectCuentaBancaria", this.setearFoco);
  },
  methods: {
    listarItems() {
      this.loading = true;
      HttpHelper.get(this.rutaApi + "ListarSelect")
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          return Promise.reject(error);
        });
    },
    setearFoco() {
      this.$refs.controlFocoSelectCuentaBancaria.focus();
    }
  }
};
</script>
